import { render } from "./AdminAccountStatement.vue?vue&type=template&id=565404d0"
import script from "./AdminAccountStatement.vue?vue&type=script&lang=js"
export * from "./AdminAccountStatement.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__